/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmUsageConversations } from "../../funcs/llmUsageConversations.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetConversationsUsageRequest$inboundSchema,
};

export const tool$llmUsageConversations: ToolDefinition<typeof args> = {
  name: "llm-usage-conversations",
  description: `Get conversations usage

Retrieve usage metrics for conversation operations.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmUsageConversations(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
